export default {
    plugins: 'basicstyles,dialogui,dialog,clipboard,button,panelbutton,panel,floatpanel,colorbutton,enterkey,entities,floatingspace,listblock,richcombo,font,format,indent,indentlist,fakeobjects,link,list,pastefromword,removeformat,stylescombo,toolbar,undo,wysiwygarea,resize,inlinesave,inlinecancel,lineutils,widget,image2,notification,justify',
    skin: 'bootstrapck',
    toolbarGroups: [
        {name: 'document', groups: ['mode', 'document', 'doctools']},
        {name: 'clipboard', groups: ['undo', 'clipboard']},
        {name: 'editing', groups: ['find', 'selection', 'spellchecker']},
        {name: 'forms'},
        {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
        {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi']},
        {name: 'insert'},
        {name: 'styles'},
        {name: 'colors'},
        {name: 'tools'},
        {name: 'others'},
        {name: 'about'},
    ],
    removeButtons: 'Anchor,Superscript,Inlinesave,Inlinecancel,Image,Copy,Paste,Cut,Subscript,FontSize,Strike,Styles',
    removeDialogTabs: 'link:advanced',
    resize_enabled: false,
    height: 500
};
